"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGenetecPassportFromHeader = exports.createGenetecCameraSyncRequest = exports.GenetecPassportHeaderDefault = exports.GenetecPassportDefault = exports.DEFAULT_RTSP_PROTOCOL = exports.DEFAULT_BUFFER_MS = void 0;
var _uuid = require("uuid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_BUFFER_MS = exports.DEFAULT_BUFFER_MS = 800;
var DEFAULT_RTSP_PROTOCOL = exports.DEFAULT_RTSP_PROTOCOL = "rtsp://";
var GenetecPassportHeaderDefault = exports.GenetecPassportHeaderDefault = function GenetecPassportHeaderDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    mediaGatewayHost: "",
    mediaGatewayPort: 0,
    mediaGatewayTls: false,
    webSdkTls: false,
    sdkPort: 0,
    useAuthentication: false,
    username: "",
    password: "",
    mediaUseAuthentication: false,
    mediaUsername: "",
    mediaPassword: "",
    streamSuffix: "",
    bufferMs: DEFAULT_BUFFER_MS,
    rtspProtocol: DEFAULT_RTSP_PROTOCOL
  };
};
var GenetecPassportDefault = exports.GenetecPassportDefault = function GenetecPassportDefault() {
  return _objectSpread(_objectSpread({}, GenetecPassportHeaderDefault()), {}, {
    isConnected: false
  });
};
var initGenetecPassportFromHeader = exports.initGenetecPassportFromHeader = function initGenetecPassportFromHeader(header) {
  var _header$useAuthentica, _header$mediaUseAuthe;
  var isConnected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return _objectSpread(_objectSpread({}, header), {}, {
    useAuthentication: (_header$useAuthentica = header.useAuthentication) !== null && _header$useAuthentica !== void 0 ? _header$useAuthentica : false,
    mediaUseAuthentication: (_header$mediaUseAuthe = header.mediaUseAuthentication) !== null && _header$mediaUseAuthe !== void 0 ? _header$mediaUseAuthe : false,
    isConnected: isConnected
  });
};
var createGenetecCameraSyncRequest = exports.createGenetecCameraSyncRequest = function createGenetecCameraSyncRequest(connectionId) {
  var cameraGuids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    connectionId: {
      value: connectionId
    },
    cameraGuids: cameraGuids
  };
};